import { SwitchOption } from "../SwitchOption";
import { WizardData } from "./AssessmentWizard";

interface Step3SettingsProps {
  data: WizardData;
  updateData: (updates: Partial<WizardData>) => void;
}

export const Step3Settings = ({ data, updateData }: Step3SettingsProps) => {
  return (
    <div className="space-y-6">
      <SwitchOption
        id="split-groups"
        label="Split documents into groups"
        description="Shows AI suggestions at the end of each group (e.g. H2 heading or task/exercise identifier). This is particularly helpful when reviewing long documents (10+ pages)."
        checked={data.groupBySection}
        onCheckedChange={(val) => updateData({ groupBySection: val })}
      />

      <div className="rounded-md bg-muted p-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-4 w-4"
            >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            You won't be able to change this later.
          </div>
      </div>
    </div>
  );
};

